import IconCheck from "@components/ui/icons/IconCheck"
import { Text } from "@components/ui/typograhpy/Text"
import { cn } from "@lib/cn"
import React, { FC, ReactNode } from "react"

type PlanCardUspProps = {
  variant?: "default" | "business" | "enterprise"
  children: ReactNode
}

export const PlanCardUsp: FC<PlanCardUspProps> = ({
  variant = "default",
  children,
}) => {
  return (
    <li className="mb-2 flex items-start">
      <span
        className={cn(
          "flex shrink-0 items-center justify-center w-[18px] h-[18px] rounded-[50%] mr-2",
          variant === "default" && "bg-sidebar-collapsible text-purple",
          variant === "business" && "bg-white text-purple",
          variant === "enterprise" && "bg-sidebar-collapsible path:stroke-gradient-fill"
        )}
        data-variant={variant}
      >
        <IconCheck size={12} />
      </span>
      <Text variant="regular">{children}</Text>
    </li>
  )
}
